
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { int32ToString, createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { concat, join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { toArray as toArray_1, empty, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { TextValue } from "../../Components/Text.js";
import { Feature, isFeatureEnabled } from "../../FeatureFlip.js";
import { unwrap, map as map_1, defaultArg } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { StocktakingListState__ToI18nString, StocktakingTypeScope__ToI18nString, StocktakingLocationScopeDto__ToI18nString, StocktakingState__ToI18nString } from "../../Shared/Stocktaking.js";
import { singleton as singleton_1, length, empty as empty_1, toArray, ofArray, map, isEmpty, reduce } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { toString } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { TableControl$1, Table } from "../../Widgets/Table/Table.js";
import { OnTableRowClick$1, ColumnDefinition$1, CellContent } from "../../Widgets/Table/Types.js";
import { StocktakingListHelperDialog } from "../Dialog/StocktakingListHelperDialog.js";
import { Msg } from "./Types.js";
import { RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { StocktakingListId__get_unwrap, StocktakingId__get_unwrap } from "../../Shared/Shared.js";
import Check from "../../../public/assets/icons/Check.svg";
import Delete_1 from "../../../public/assets/icons/Delete_1.svg";
import Qr_Code from "../../../public/assets/icons/Qr_Code.svg";
import { ChangelogTable } from "../../Widgets/Table/ChangelogTable.js";
import { ConfirmationDialog } from "../../Components/Dialog.js";
import { TextButton } from "../../Components/Button.js";
import Shipment_Time from "../../../public/assets/icons/Shipment_Time.svg";
import { DetailViewHeader } from "../../Widgets/DetailViewHeader.js";
import { AreaAnchorMenu } from "../../Widgets/AnchorMenu.js";
import { TableContainer } from "../../Widgets/Container.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, initViewStocktaking } from "./State.js";
import { Skeleton } from "../../Components/Skeleton.js";

function OverviewInformationSection(props) {
    let elems_1, elems;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems = toList(delay(() => append(singleton(createElement(TextValue, {
        FontWeight: "bold",
        TestId: "overview-description-label",
        Text: t("general.description"),
    })), delay(() => append(singleton(createElement(TextValue, {
        FontWeight: "normal",
        TestId: "overview-description-value",
        Text: props.Stocktaking.Description,
    })), delay(() => append(isFeatureEnabled(new Feature(17, [])) ? (props.AccountSettings.BusinessUnitsEnabled ? append(singleton(createElement(TextValue, {
        FontWeight: "bold",
        TestId: "overview-business-unit-label",
        Text: t("business_units.business_unit"),
    })), delay(() => singleton(createElement(TextValue, {
        FontWeight: "normal",
        TestId: "overview-business-unit-value",
        Text: defaultArg(props.Stocktaking.BusinessUnitName, ""),
    })))) : empty()) : empty(), delay(() => append(singleton(createElement(TextValue, {
        FontWeight: "bold",
        TestId: "overview-state-label",
        Text: t("general.state"),
    })), delay(() => append(singleton(createElement(TextValue, {
        FontWeight: "normal",
        TestId: "overview-state-value",
        Text: t(StocktakingState__ToI18nString(props.Stocktaking.State)),
    })), delay(() => append(singleton(createElement(TextValue, {
        FontWeight: "bold",
        TestId: "overview-scope-label",
        Text: t("stocktaking.location_scope.title"),
    })), delay(() => {
        let matchValue, storageNames, receiverNames;
        return append(singleton(createElement(TextValue, {
            FontWeight: "normal",
            TestId: "overview-scope-value",
            Text: (matchValue = props.Stocktaking.LocationScope, (matchValue.tag === 1) ? ((storageNames = reduce((result, storage) => concat(result, ", ", ...storage), matchValue.fields[0]), concat(t(StocktakingLocationScopeDto__ToI18nString(props.Stocktaking.LocationScope)), " (", storageNames, ...")"))) : ((matchValue.tag === 2) ? ((storageNames = reduce((result, storage) => concat(result, ", ", ...storage), matchValue.fields[0]), concat(t(StocktakingLocationScopeDto__ToI18nString(props.Stocktaking.LocationScope)), " (", storageNames, ...")"))) : ((matchValue.tag === 3) ? ((receiverNames = reduce((result_1, receiver) => concat(result_1, ", ", ...receiver), matchValue.fields[0]), concat(t(StocktakingLocationScopeDto__ToI18nString(props.Stocktaking.LocationScope)), " (", receiverNames, ...")"))) : t(StocktakingLocationScopeDto__ToI18nString(props.Stocktaking.LocationScope))))),
        })), delay(() => append(singleton(createElement(TextValue, {
            FontWeight: "bold",
            TestId: "overview-scope-label",
            Text: t("stocktaking.type_scope.title"),
        })), delay(() => append(singleton(createElement(TextValue, {
            FontWeight: "normal",
            TestId: "overview-scope-value",
            Text: isEmpty(props.Stocktaking.TypeScope) ? "" : reduce((result_2, typeScope) => concat(result_2, ", ", ...typeScope), map((arg) => t(StocktakingTypeScope__ToI18nString(arg)), props.Stocktaking.TypeScope)),
        })), delay(() => append(singleton(createElement(TextValue, {
            FontWeight: "bold",
            TestId: "overview-storage-blocked-label",
            Text: t("stocktaking.details_storage_blocked"),
        })), delay(() => append(singleton(createElement(TextValue, {
            FontWeight: "normal",
            TestId: "overview-storage-blocked-value",
            Text: t(props.Stocktaking.ToolsCanBeTaken ? "general.no" : "general.yes"),
        })), delay(() => append(singleton(createElement(TextValue, {
            FontWeight: "bold",
            TestId: "overview-scanner-required-label",
            Text: t("stocktaking.details_scanner_required"),
        })), delay(() => append(singleton(createElement(TextValue, {
            FontWeight: "normal",
            TestId: "overview-scanner-required-value",
            Text: t(props.Stocktaking.IsScannerRequired ? "general.no" : "general.yes"),
        })), delay(() => append(singleton(createElement(TextValue, {
            FontWeight: "bold",
            TestId: "overview-stocktaking-time",
            Text: t("stocktaking.stocktaking_time"),
        })), delay(() => singleton(createElement(TextValue, {
            FontWeight: "normal",
            TestId: "overview-stocktaking-time-value",
            Text: concat(toString(props.Stocktaking.StartDate, "dd.MM.yyyy"), " - ", ...toString(props.Stocktaking.EndDate, "dd.MM.yyyy")),
        }))))))))))))))))));
    })))))))))))))), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function ResponsiblePersonTable(props) {
    let elems, TableRows;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "grow"])], (elems = [createElement(Table, (TableRows = toArray(props.Stocktaking.ResponsiblePersons), {
        ColumnDefinitions: [new ColumnDefinition$1("name", "", t("general.name"), (dto) => (new CellContent(0, [dto.Name])), "text", "text"), new ColumnDefinition$1("department", "", t("user.department"), (dto_1) => (new CellContent(0, [dto_1.Department])), "text", "text")],
        Controls: empty_1(),
        Options: {
            BorderStyle: "row",
            CSVDownload: false,
            ConfigurableColumns: false,
            CustomTableFilters: false,
            DefaultSortColumn: ["name", "asc"],
            Fullscreen: false,
            GlobalSearch: false,
            RowSelection: "disabled",
            SaveTableConfiguration: false,
        },
        TableKey: "not-defined-table",
        TableRows: TableRows,
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function HelperTable(props) {
    let elems, TableRows;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems = [createElement(Table, (TableRows = toArray(props.Stocktaking.Helpers), {
        ColumnDefinitions: [new ColumnDefinition$1("name", "", t("general.name"), (dto) => (new CellContent(0, [dto.Name])), "text", "text"), new ColumnDefinition$1("department", "", t("user.department"), (dto_1) => (new CellContent(0, [dto_1.Department])), "text", "text")],
        Controls: empty_1(),
        Options: {
            BorderStyle: "row",
            CSVDownload: false,
            ConfigurableColumns: false,
            CustomTableFilters: false,
            DefaultSortColumn: ["name", "asc"],
            Fullscreen: false,
            GlobalSearch: false,
            RowSelection: "disabled",
            SaveTableConfiguration: false,
        },
        TableKey: "not-defined-table",
        TableRows: TableRows,
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function StocktakingListsTable(props) {
    let elems_2, TableRows, Options;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(empty_1());
    const setStocktakingListHelperDialogIsOpen = patternInput_1[1];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "grow"])], (elems_2 = [createElement(StocktakingListHelperDialog, {
        IsOpen: patternInput_1[0],
        OnClose: () => {
            setStocktakingListHelperDialogIsOpen(empty_1());
            props.Dispatch(new Msg(0, []));
        },
        Stocktaking: props.Stocktaking,
        Users: props.Users,
    }), createElement(Table, (TableRows = toArray(props.Stocktaking.StocktakingLists), (Options = {
        BorderStyle: "row",
        CSVDownload: false,
        ConfigurableColumns: false,
        CustomTableFilters: false,
        DefaultSortColumn: ["scope", "asc"],
        Fullscreen: false,
        GlobalSearch: false,
        OnRowClick: new OnTableRowClick$1(0, [(dto_7) => {
            RouterModule_nav(ofArray(["stocktaking", StocktakingId__get_unwrap(props.Stocktaking.Id), "lists", StocktakingListId__get_unwrap(dto_7.Id)]), 1, 1);
        }]),
        RowSelection: "multiRow",
        SaveTableConfiguration: false,
    }, {
        ColumnDefinitions: toArray_1(delay(() => {
            let matchValue;
            return append((matchValue = props.Stocktaking.State, (matchValue.tag === 0) ? (empty()) : ((matchValue.tag === 1) ? (empty()) : ((matchValue.tag === 2) ? (empty()) : ((matchValue.tag === 4) ? (empty()) : singleton(new ColumnDefinition$1("status_icon", "", t("stocktaking.status"), (dto) => {
                let matchValue_1, elems_1, requiredActions_1, elems;
                return new CellContent(1, [(matchValue_1 = dto.RequiredActionsCount, (matchValue_1 == null) ? reactElement("div", createObj(ofArray([["className", join(" ", ["text-primary", "h-5", "w-5"])], (elems_1 = [Check()], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))) : ((matchValue_1 > 0) ? ((requiredActions_1 = (matchValue_1 | 0), reactElement("div", createObj(ofArray([["className", join(" ", ["text-red", "h-5", "w-5"])], (elems = [Delete_1()], ["children", reactApi.Children.toArray(Array.from(elems))])]))))) : reactElement("div", createObj(ofArray([["className", join(" ", ["text-primary", "h-5", "w-5"])], (elems_1 = [Check()], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))))]);
            }, "none", "text")))))), delay(() => append(singleton(new ColumnDefinition$1("scope", "", t("stocktaking.scope"), (dto_1) => (new CellContent(0, [dto_1.DisplayName])), "select", "text")), delay(() => append(singleton(new ColumnDefinition$1("affectedElements", "", t("stocktaking.affected_elements"), (dto_2) => (new CellContent(0, [int32ToString((length(dto_2.Tools) + length(dto_2.ToolsWithQuantity)) + length(dto_2.Consumables))])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("helper", "", t("stocktaking.stocktaking_helper"), (dto_3) => (new CellContent(0, [isEmpty(dto_3.Helper) ? "" : reduce((e1, e2) => concat(e1, ",", ...e2), map((helper) => helper.Name, dto_3.Helper))])), "select", "text")), delay(() => append(singleton(new ColumnDefinition$1("state", "", t("stocktaking.stocktaking_list_state"), (dto_4) => (new CellContent(0, [t(StocktakingListState__ToI18nString(dto_4.State))])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("progress", "", t("stocktaking.stocktaking_list_progress"), (dto_5) => (new CellContent(0, [defaultArg(map_1((arg) => concat(int32ToString(arg), ..."%"), dto_5.Progress), "")])), "text", "text")), delay(() => singleton(new ColumnDefinition$1("requiredActionsCount", "", t("stocktaking.required_actions"), (dto_6) => (new CellContent(0, [defaultArg(map_1(int32ToString, dto_6.RequiredActionsCount), "")])), "text", "text"))))))))))))));
        })),
        Controls: toList(delay(() => {
            const matchValue_2 = props.Stocktaking.State;
            switch (matchValue_2.tag) {
                case 1:
                case 0:
                    return singleton(new TableControl$1(t("stocktaking.assign_stocktaking_helper_to_list"), Qr_Code(), (dto_8) => {
                        setStocktakingListHelperDialogIsOpen(map((l) => l.Id, dto_8));
                    }, true, false, "stocktaking-assign-helper-to-list"));
                default: {
                    return empty();
                }
            }
        })),
        Options: Options,
        TableKey: "not-defined-table",
        TableRows: TableRows,
    })))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

function HistoryTable(props) {
    let elems;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems = [createElement(ChangelogTable, {
        Changelogs: props.Stocktaking.Changelogs,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function DetailsActions(props) {
    let elems_1, Title, Title_1, Title_2, Title_3, elems;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-between"])], (elems_1 = [createElement(ConfirmationDialog, (Title = t("stocktaking.dialog.state_to_fixed_title"), {
        Description: t("stocktaking.dialog.state_to_fixed_description"),
        FormState: props.FormState,
        IsOpen: props.DialogOpenState.IsConfirmationStateFixedDialogOpen,
        OnClose: () => {
            props.Dispatch(new Msg(8, [false]));
        },
        OnConfirm: () => {
            props.Dispatch(new Msg(4, []));
        },
        Title: Title,
    })), createElement(ConfirmationDialog, (Title_1 = t("stocktaking.dialog.state_to_start_title"), {
        Description: t("stocktaking.dialog.state_to_start_description"),
        FormState: props.FormState,
        IsOpen: props.DialogOpenState.IsConfirmationStateStartDialogOpen,
        OnClose: () => {
            props.Dispatch(new Msg(9, [false]));
        },
        OnConfirm: () => {
            props.Dispatch(new Msg(5, []));
        },
        Title: Title_1,
    })), createElement(ConfirmationDialog, (Title_2 = t("stocktaking.dialog.state_to_done_title"), {
        Description: t("stocktaking.dialog.state_to_done_description"),
        FormState: props.FormState,
        IsOpen: props.DialogOpenState.IsConfirmationStateDoneDialogOpen,
        OnClose: () => {
            props.Dispatch(new Msg(10, [false]));
        },
        OnConfirm: () => {
            props.Dispatch(new Msg(6, []));
        },
        Title: Title_2,
    })), createElement(ConfirmationDialog, (Title_3 = t("stocktaking.dialog.state_to_closed_title"), {
        Description: t("stocktaking.dialog.state_to_closed_description"),
        FormState: props.FormState,
        IsOpen: props.DialogOpenState.IsConfirmationStateClosedDialogOpen,
        OnClose: () => {
            props.Dispatch(new Msg(11, [false]));
        },
        OnConfirm: () => {
            props.Dispatch(new Msg(7, []));
        },
        Title: Title_3,
    })), reactElement("div", {}), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "gap-7"])], (elems = toList(delay(() => {
        let Label_1, Label_2, Label_3, Label_4, Label;
        const matchValue = props.Stocktaking.State;
        return (matchValue.tag === 1) ? singleton(createElement(TextButton, (Label_1 = t("stocktaking.state.to_start"), {
            ComponentState: "enabled",
            Icon: Shipment_Time(),
            Label: Label_1,
            OnClick: () => {
                props.Dispatch(new Msg(9, [true]));
            },
            TestId: "tool-tooldetail-in-maintenance-state-button",
            Variant: "default",
        }))) : ((matchValue.tag === 2) ? singleton(createElement(TextButton, (Label_2 = t("stocktaking.state.to_done"), {
            ComponentState: "enabled",
            Icon: Shipment_Time(),
            Label: Label_2,
            OnClick: () => {
                props.Dispatch(new Msg(10, [true]));
            },
            TestId: "tool-tooldetail-in-maintenance-state-button",
            Variant: "default",
        }))) : ((matchValue.tag === 3) ? singleton(createElement(TextButton, (Label_3 = t("stocktaking.state.to_closed"), {
            ComponentState: "enabled",
            Icon: Shipment_Time(),
            Label: Label_3,
            OnClick: () => {
                props.Dispatch(new Msg(11, [true]));
            },
            TestId: "tool-tooldetail-in-maintenance-state-button",
            Variant: "default",
        }))) : ((matchValue.tag === 4) ? singleton(createElement(TextButton, (Label_4 = t("stocktaking.show_stocktaking_result"), {
            ComponentState: "enabled",
            Icon: Shipment_Time(),
            Label: Label_4,
            OnClick: () => {
                RouterModule_nav(ofArray(["stocktaking", StocktakingId__get_unwrap(props.Stocktaking.Id), "result"]), 1, 1);
            },
            TestId: "tool-tooldetail-show-stocktaking-result-button",
            Variant: "default",
        }))) : singleton(createElement(TextButton, (Label = t("stocktaking.state.to_fixed"), {
            ComponentState: "enabled",
            Icon: Shipment_Time(),
            Label: Label,
            OnClick: () => {
                props.Dispatch(new Msg(8, [true]));
            },
            TestId: "tool-tooldetail-in-maintenance-state-button",
            Variant: "default",
        }))))));
    })), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function OverviewSection(props) {
    let elems_2, elems_1, elems;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "grow"])], (elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", ["bg-white", "rounded", "px-12", "py-9"])], (elems_1 = [DetailsActions({
        DialogOpenState: props.DialogOpenState,
        Dispatch: props.Dispatch,
        FormState: props.FormState,
        Stocktaking: props.Stocktaking,
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "mt-6"])], (elems = [createElement(OverviewInformationSection, {
        AccountSettings: props.AccountSettings,
        Stocktaking: props.Stocktaking,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

function DetailViewComponent(props) {
    let elems_9, Title, elems_8, elems, matchValue, elems_7, elems_6, elems_1, elems_2, Title_2, elems_3, Title_3, elems_4, Title_4, elems_5, Title_5;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState("overview-section");
    const patternInput_2 = reactApi.useState(false);
    const setIsDeleteModalOpen = patternInput_2[1];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "grow", "flex-col"])], (elems_9 = [createElement(ConfirmationDialog, (Title = t("stocktaking.delete_stocktaking"), {
        Description: t("stocktaking.delete_stocktaking_confirmation"),
        IsOpen: patternInput_2[0],
        OnClose: () => {
            setIsDeleteModalOpen(false);
        },
        OnConfirm: () => {
            props.Dispatch(new Msg(2, []));
        },
        Title: Title,
    })), reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-[10rem,min(calc(100vw-16rem-2px-28px-11rem),80rem)]"])], (elems_8 = [reactElement("div", createObj(ofArray([["className", join(" ", ["col-span-2"])], (elems = [createElement(DetailViewHeader, {
        Badges: empty_1(),
        OnBack: () => {
            RouterModule_nav(ofArray(["stocktaking"]), 1, 1);
        },
        OnDelete: () => {
            setIsDeleteModalOpen(true);
        },
        OnDuplicate: () => {
            RouterModule_nav(ofArray(["stocktaking", StocktakingId__get_unwrap(props.Stocktaking.Id), "copy"]), 1, 1);
        },
        OnEdit: unwrap((matchValue = props.Stocktaking.State, (matchValue.tag === 0) ? (() => {
            RouterModule_nav(ofArray(["stocktaking", StocktakingId__get_unwrap(props.Stocktaking.Id), "edit"]), 1, 1);
        }) : ((matchValue.tag === 2) ? undefined : ((matchValue.tag === 3) ? undefined : ((matchValue.tag === 4) ? undefined : (() => {
            RouterModule_nav(ofArray(["stocktaking", StocktakingId__get_unwrap(props.Stocktaking.Id), "edit"]), 1, 1);
        })))))),
        Title: props.Stocktaking.Name,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement(AreaAnchorMenu, {
        Anchors: ofArray([{
            Id: "overview-section",
            Label: t("general.overview"),
        }, {
            Id: "stocktaking-lists-section",
            Label: t("stocktaking.stocktaking_lists"),
        }, {
            Id: "responsible-section",
            Label: t("stocktaking.responsible_person"),
        }, {
            Id: "helper-section",
            Label: t("stocktaking.stocktaking_helper"),
        }, {
            Id: "history-section",
            Label: t("general.history"),
        }]),
        OnSelectAnchor: patternInput_1[1],
        SelectedAnchor: patternInput_1[0],
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["pr-3"])], (elems_7 = [reactElement("div", createObj(singleton_1((elems_6 = [reactElement("div", createObj(ofArray([["id", "overview-section"], (elems_1 = [createElement(OverviewSection, {
        AccountSettings: props.AccountSettings,
        DialogOpenState: props.DialogOpenState,
        Dispatch: props.Dispatch,
        FormState: props.FormState,
        Stocktaking: props.Stocktaking,
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), reactElement("section", createObj(ofArray([["id", "stocktaking-lists-section"], (elems_2 = [createElement(TableContainer, (Title_2 = t("stocktaking.stocktaking_lists"), {
        Content: createElement(StocktakingListsTable, {
            Dispatch: props.Dispatch,
            Stocktaking: props.Stocktaking,
            Users: props.Users,
        }),
        Title: unwrap(Title_2),
    }))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), reactElement("section", createObj(ofArray([["id", "responsible-section"], (elems_3 = [createElement(TableContainer, (Title_3 = t("stocktaking.responsible_person"), {
        Content: createElement(ResponsiblePersonTable, {
            Stocktaking: props.Stocktaking,
        }),
        Title: unwrap(Title_3),
    }))], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))), reactElement("section", createObj(ofArray([["id", "helper-section"], (elems_4 = [createElement(TableContainer, (Title_4 = t("stocktaking.stocktaking_helper"), {
        Content: createElement(HelperTable, {
            Stocktaking: props.Stocktaking,
        }),
        Title: unwrap(Title_4),
    }))], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))), reactElement("section", createObj(ofArray([["id", "history-section"], (elems_5 = [createElement(TableContainer, (Title_5 = t("general.history"), {
        Content: createElement(HistoryTable, {
            Stocktaking: props.Stocktaking,
        }),
        Title: unwrap(Title_5),
    }))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))], ["children", reactApi.Children.toArray(Array.from(elems_6))]))))], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))], ["children", reactApi.Children.toArray(Array.from(elems_8))])])))], ["children", reactApi.Children.toArray(Array.from(elems_9))])])));
}

export function DetailView(props) {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(initViewStocktaking, update_1, (_arg, _arg_1) => {
    }), props.StocktakingId, undefined);
    const state_1 = patternInput[0];
    const matchValue = state_1.Stocktaking;
    const matchValue_1 = state_1.Users;
    const matchValue_2 = state_1.AccountSettings;
    let matchResult, accountSettings, stocktaking, users;
    if (matchValue.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_1.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_2.tag === 0) {
        matchResult = 1;
    }
    else {
        matchResult = 0;
        accountSettings = matchValue_2.fields[0];
        stocktaking = matchValue.fields[0];
        users = matchValue_1.fields[0];
    }
    switch (matchResult) {
        case 0:
            return createElement(DetailViewComponent, {
                AccountSettings: accountSettings,
                DialogOpenState: state_1.DialogOpenState,
                Dispatch: patternInput[1],
                FormState: state_1.FormState,
                Stocktaking: stocktaking,
                Users: users,
            });
        default:
            return createElement(Skeleton, {
                Variant: "detail",
            });
    }
}

